import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import Preloader from "../helper/Preloader";
import Animation from "../helper/Animation";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import { fetchgalleryImages } from "../api/GalleryApi";
import GalleryViewSction from "../components/GalleryViewSction";
import { FetchAllApi } from "../components/FetchAllApi";
import { useAllDataContext } from "../context/AllDataContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const GalleryViewPage = () => {
  const location = useLocation();
  const { companyDetailsData, setCompanyDetailsData } =
      useCompanyDetailsContext();
  const [subBreadcrumbTitle, setSubBreadcrumbTitle] = useState();
  const { setLoading } = useLoader();
  const [galleryImagesData, setGalleryImagesData] = useState([]);
  const { allData, setAllData } = useAllDataContext();

  const galleryViewBannerData = allData.allBannerData[0]?.gallery_preview_title;

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchgalleryImages()])
      .then(([galleryImage]) => {
        setGalleryImagesData(galleryImage);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch(() => {
        console.error("Server Error");
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
  }, [setLoading]);
  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        heading={galleryViewBannerData}
        title={"Gallery"}
        subTitle={subBreadcrumbTitle}
        goBack={true}
      />

      {/* GallerySection */}
      <GalleryViewSction
        id={location.state.id}
        galleryImagesData={galleryImagesData}
        setSubBreadcrumbTitle={setSubBreadcrumbTitle}
      />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default GalleryViewPage;
